// extracted by mini-css-extract-plugin
export default {"container":"Sumatealequipo_container__O05q-"};